import classes from "./ThreeDotsModal.module.css";
import { EditIcon } from "../../images/deliveries/deliveriesModals/editIcon";
import { ClockIcon } from "../../images/drivers/clockIcon";
import { DeleteIcon } from "../../images/deliveries/deliveriesModals/deleteIcon";
import { useLocation } from "react-router-dom";
import { LocationIcon } from "../../images/drivers/locationIcon";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import {
  onDelete,
  onEdit,
  toggleAddNewDriverModal,
  toggleDriverInfoModal,
  toggleThreeDotsModal,
  setIsDriverRoutes,
  setShowThreeDotsModal,
  setIsOrderInformationOpen,
  setDeliveriesToDisplay,
} from "../../redux/globalFunctions/globalFnSlice";

export function ThreeDotsModal() {
  const { modalPosition, isWithHistory, selectedDriverId } = useSelector(
    (state) => state.global
  );
  const { deliveries } = useSelector((state) => state.deliveries);

  const location = useLocation();
  const modalRef = useRef(null);
  const dispatch = useDispatch();

  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsClosing(true);
        setTimeout(() => {
          dispatch(setShowThreeDotsModal(false));
        }, 300); // Wait for animation to finish
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dispatch]);

  function handleEditClick() {
    if (isWithHistory) dispatch(toggleAddNewDriverModal());
    else dispatch(onEdit());
  }

  function openOrderInformation() {
    dispatch(setShowThreeDotsModal(false));
    dispatch(setDeliveriesToDisplay(deliveries));
    dispatch(setIsOrderInformationOpen(true));
  }

  function handleHistoryClick() {
    dispatch(toggleThreeDotsModal(selectedDriverId));
    dispatch(toggleDriverInfoModal());
    dispatch(setIsDriverRoutes(false));
  }

  return (
    <div
      ref={modalRef}
      className={`${classes.threeDotsModal} ${
        isClosing ? classes.fadeOut : classes.fadeIn
      }`}
      style={{
        position: "absolute",
        top: modalPosition.y,
        left: modalPosition.x,
      }}
    >
      <div className={classes.btns}>
        {location.pathname === "/deliveries" && (
          <LocationIcon onClick={openOrderInformation} />
        )}
        {isWithHistory && <ClockIcon onClick={handleHistoryClick} />}
        <EditIcon onClick={handleEditClick} />
        <DeleteIcon onClick={() => dispatch(onDelete())} />
      </div>
      <div
        className={
          isWithHistory || location.pathname === "/deliveries"
            ? classes.squareDivHistory
            : classes.squareDiv
        }
      ></div>
    </div>
  );
}
